"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_TAG_SHOWN = exports.TagSortState = void 0;
var core_api_1 = require("@ikegps/core-api");
var icons_1 = require("../components/icon/icons");
var sortable_1 = require("../components/sortable/sortable");
var i18n_1 = require("../i18n");
var i18n_2 = require("../i18n");
var services_1 = require("../services");
var store_1 = require("../store");
var userDisplayName_1 = require("../util/userDisplayName");
function getCollectedBy(obj) {
    if (obj.collectedBy == null) {
        return null;
    }
    var user = store_1.AppStore.UserProfile.get(obj.collectedBy);
    if (user == null) {
        return null;
    }
    return user.username;
}
function getUpdatedAt(obj) {
    return obj.updatedAt || obj.createdAt;
}
function getDisplayUpdatedAt(obj) {
    return obj.updatedAt != null ? services_1.Services.DateTime.getDate(obj.updatedAt) : services_1.Services.DateTime.getDate(obj.createdAt);
}
function getAssignedTo(obj) {
    var userProfile = store_1.AppStore.UserProfile.get(obj.assignedTo);
    if (userProfile != null) {
        return (0, userDisplayName_1.userDisplayName)(userProfile);
    }
    return (0, i18n_1.Translate)(i18n_2.T.COLLECTION_UNASSIGNED);
}
var UNSORTED_KEY = '';
var SORT_OPTIONS = [{
        title: i18n_2.T.SORT_FIELD_UPDATED_AT,
        icon: icons_1.MaterialIcon.UPDATE,
        keys: {
            tag: getUpdatedAt,
            collection: getUpdatedAt
        },
        value: {
            collection: getDisplayUpdatedAt
        },
        info: {
            tag: true,
            collection: true
        }
    }, {
        title: i18n_2.T.SORT_FIELD_COLLECTED_AT,
        icon: icons_1.MaterialIcon.DATE,
        keys: {
            tag: 'createdAt',
            collection: function (summary) {
                return summary.collectedAt != null ? summary.collectedAt.iso : summary.createdAt;
            }
        },
        value: {
            collection: function (summary) {
                return summary.collectedAt != null ? services_1.Services.DateTime.getDate(summary.collectedAt.iso) : services_1.Services.DateTime.getDate(summary.createdAt);
            }
        },
        info: {
            tag: true,
            collection: true
        }
    }, {
        title: i18n_2.T.SORT_FIELD_NAME,
        icon: icons_1.MaterialIcon.SHORT_TEXT,
        keys: {
            tag: 'name',
            collection: 'title'
        },
        info: {}
    }, {
        title: i18n_2.T.SORT_FIELD_COLLECTED_BY,
        icon: icons_1.MaterialIcon.PERSON,
        keys: {
            tag: UNSORTED_KEY,
            collection: getCollectedBy
        },
        info: {
            collection: true
        }
    }, {
        title: i18n_2.T.SORT_FIELD_STATUS,
        icon: icons_1.MaterialIcon.STATUS,
        visible: function () { return (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_SORT_STATUS) || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)); },
        keys: {
            tag: UNSORTED_KEY,
            collection: 'status'
        },
        info: {
            collection: true
        }
    }, {
        title: i18n_2.T.SORT_FIELD_ASSIGNED,
        icon: icons_1.MaterialIcon.ASSIGN,
        visible: function () { return (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_ASSIGN) || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)); },
        keys: {
            tag: UNSORTED_KEY,
            collection: getAssignedTo
        },
        info: {
            collection: true
        }
    }];
exports.TagSortState = new sortable_1.SortableState(SORT_OPTIONS);
exports.MAX_TAG_SHOWN = 50;
//# sourceMappingURL=tag.sort.state.js.map